const KEY = "cfaa_theme";

function systemTheme() {
  return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

// The user's explicit choice, or null if they've never chosen (first login).
export function getStoredChoice() {
  return localStorage.getItem(KEY);
}

// Effective theme to display: explicit choice if set, otherwise the device setting.
export function getStoredTheme() {
  return getStoredChoice() || systemTheme();
}

export function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
}

export function initTheme() {
  applyTheme(getStoredTheme());
  // Keep following the device until the user makes an explicit choice.
  if (!getStoredChoice() && window.matchMedia) {
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (e) => {
      if (!getStoredChoice()) applyTheme(e.matches ? "dark" : "light");
    });
  }
}

export function setTheme(theme) {
  localStorage.setItem(KEY, theme);
  applyTheme(theme);
}
